// @module C3.ShoppingExtensions.NewsletterSignup
define('C3.ShoppingExtensions.NewsletterSignup.FooterForm'
,   [
        'c3_shoppingextensions_newslettersignup_footerform.tpl'
    ,   'Backbone'  
    ,   'Backbone.FormView'
    ,   'Backbone.CompositeView'
    ,   'GlobalViews.Message.View'
    ,   'C3.ShoppingExtensions.NewsletterSignup.View'
    ,   'AAMS.OffersExtension.Offers.RightSide.View'
    ,   'C3.ShoppingExtensions.NewsletterSignup.Model'
    ,   'GoogleTagManager'
    ,   'Tracker'
    ,   'Profile.Model'
    ,   'C3.ShoppingExtensions.NewsletterSignupCompany.View'
    ,   'C3.ShoppingExtensions.NewsletterSignupCompany.Model'
    ,   'underscore'
    ,   'js.cookie'
    ,   'Utils'
    ]
, function (
        c3_shoppingextensions_newslettersignup_footerform_tpl
    ,   Backbone
    ,   BackboneCompositeView
    ,   BackboneFormView
    ,   GlobalViewsMessageView
    ,   NewsletterSignupView
    ,   OffersRightSideView
    ,   NewsletterSignupModel
    ,   GoogleTagManager
    ,   Tracker
    ,   ProfileModel
    ,   NewsletterSignupCompanyView
    ,   NewsletterSignupCompanyModel
    ,   _
    ,   Cookies
    ,   Utils
)
{
    'use strict';

    // @class C3.ShoppingExtensions.NewsletterSignup.View @extends Backbone.View
    return Backbone.View.extend({

        template: c3_shoppingextensions_newslettersignup_footerform_tpl

    , attributes: {
        id: 'newsletter-signupform'
    }   
        
    ,   events: {
            'submit form': 'submitForm'
        }

    ,   bindings: {
            '[name="email"]': 'email'
        }

    ,   initialize: function (options) {
            this.state = {
                code: '',
                message: '',
                messageType: ''
            };

            this.application = options.application;
            this.model = options.model || new NewsletterSignupModel();

            var profile = ProfileModel.getInstance()
            this.is_logged_in = profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F'
            
            if(this.is_logged_in)
            this.loggedUserEmail = profile.get('email');
            this.isPhoneDevice = Utils.isPhoneDevice();
            BackboneCompositeView.add(this);
            BackboneFormView.add(this);
        }    

    ,   feedback: {
            OK: {
                type: 'success',
                message: _('Thank you! Welcome to our newsletter').translate()
            },
            ERR_USER_STATUS_ALREADY_SUBSCRIBED: {
                type: 'warning',
                message: _('Sorry, the specified email is already subscribed.').translate()
            },
            ERR_USER_STATUS_DISABLED: {
                type: 'error',
                message: _('Sorry, the specified email cannot be subscribed.').translate()
            },
            ERROR: {
                type: 'error',
                message: _('Sorry, subscription cannot be done. Try again later.').translate()
            }
        }

    ,   submitForm: function(e) {
            e.preventDefault();
            const self = this;
            const data = (jQuery(e.target).closest('form')).serializeObject();
            //console.log(data)

            var Layout = this.application.getComponent('Layout');
            //console.log(Layout)

            /*var NewsletterPopupForm = new NewsletterSignupView({
                application : self.application,
                model : new NewsletterSignupModel(),
                userEmail : data.email,
                userId : '1410028'
            })

            if (NewsletterPopupForm)
            Layout.showContent(NewsletterPopupForm, {showInModal: true});*/

            //console.log(this)
            //const self = this;
            const promise = this.saveForm(e);
            
            var IDPARAM = "#"
            if(self.isPhoneDevice)
                IDPARAM = "#in-modal-"
            //console.log(IDPARAM);

            if (promise) {
                promise
                    .fail(function(jqXhr) {
                        //console.log(jqXhr.responseJSON)
                        jqXhr.preventDefault = true;
                        $('.newsletter-alert-placeholder').html("");
                        const errorCode =
                            jqXhr &&
                            jqXhr.responseJSON &&
                            jqXhr.responseJSON.errorCode &&
                            self.feedback[jqXhr.responseJSON.errorCode]
                                ? jqXhr.responseJSON.errorCode
                                : 'ERROR';

                        self.state.code = errorCode;
                        self.state.message = self.feedback[errorCode].message;
                        self.state.messageType = self.feedback[errorCode].type;
                    })
                    .done(function(res) {
                        //console.log(res)
                        var userInfo = []
                        if(res.code == 'OK')
                        {
                            userInfo = res.user;

                            //Snippet for GTM DataLayer
                            const gtm = GoogleTagManager;
                            const eventName = 'identifyUser';
                             const eventData = {
                                event: eventName,
                                userEmail: userInfo.email
                             }
                            
                             Tracker.trigger(eventName, eventData);
                             gtm.pushData(eventData);
                             //console.log(gtm.win); 
                            // console.log(userInfo.email)
                            var _etmc = [];
                            _etmc.push(["setUserInfo", {"email": userInfo.email }]);
                            _etmc.push(['trackPageView']);

                        }
                        else if(res.code == 'UPDATE'){
                            userInfo = res.user[0]
                        }
                        //console.log(userInfo)                                 
                        var Layout = self.application.getComponent('Layout');
                        var isPerson = userInfo.isperson
                        if(jQuery('.newsletter-suscription-form-input').val()!=null 
                                && jQuery('.newsletter-suscription-form-input').val()!=" ") 
                        {
                            if(self.isPhoneDevice)
                                 var $OffersElement = jQuery('[data-action="show-mobile-offers"]');
                            else
                            {
                                var $OffersElement = jQuery('[data-action="hide-categories-nav"]').filter(function() {
                                return jQuery(this).text().trim() === "Offers";
                                });
                            }
                                
                            $OffersElement.trigger('click',true)
                            setTimeout(function () {
                            jQuery(IDPARAM+'register-email').val(jQuery('.newsletter-suscription-form-input').val());
                            jQuery(IDPARAM+'register-email').prop('disabled', true);

                            if(userInfo)
                            {
                                jQuery('.offers-checkbox').attr('checked',false)
                                jQuery('.offers-checkbox').attr('value',"")
                                
                                var emailPreferencesArray = userInfo.emailpreferences
                                var productInterestsArray = userInfo.productinterests

                                if(emailPreferencesArray)
                                var splitEmailPreferencesArray = emailPreferencesArray.split(',')

                                if(userInfo.optin=='T')
                                  jQuery(IDPARAM+'email-preferences-subscribe-all').attr('checked',true)  
                                
                                if(userInfo.firstname && userInfo.firstname =="firstname")
                                    jQuery(IDPARAM+'register-firstname').val();
                                else
                                    jQuery(IDPARAM+'register-firstname').val(userInfo.firstname);
                                
                                if(userInfo.lastname && userInfo.lastname=="lastname")
                                    jQuery(IDPARAM+'register-lastname').val();
                                else
                                    jQuery(IDPARAM+'register-lastname').val(userInfo.lastname);
                                
                                if(userInfo.custentity_destination_country && userInfo.custentity_destination_country!="")
                                    jQuery(IDPARAM+'market-country').val(userInfo.custentity_destination_country);
                               /* else
                                {
                                    $.get("https://ipinfo.io", function(response){
                                        jQuery("#market-country").val(jQuery("#market-country option[data-option='"+response.country+"']").val()).change();
                                    }, "jsonp");
                                }*/
                                
                                jQuery(IDPARAM+'update-prospect').val("T");
                                jQuery(IDPARAM+'prospect-id').val(userInfo.internalid);
                                
                                if(emailPreferencesArray){
                                    _.each(splitEmailPreferencesArray,function(line){
                                        if(line == '1'){
                                            //weekly_deals_enabled = true;
                                            jQuery(IDPARAM+'email-preferences-weekly-deals').attr('checked',true)
                                        }
                                        if(line == '101'){
                                            //make_an_offer_enabled = true;
                                            jQuery(IDPARAM+'email-preferences-make-offer').attr('checked',true)
                                        }
                                        if(line == '102'){
                                           // new_arrivals_enabled = true;
                                            jQuery(IDPARAM+'email-preferences-new-arrivals').attr('checked',true)
                                        }
                                        if(line == '103'){
                                            //recommended_for_you_enabled = true;
                                            jQuery(IDPARAM+'email-preferences-recommendedforyou').attr('checked',true)
                                        }
                                         if(line == '113'){
                                            //recommended_for_you_enabled = true;
                                            jQuery(IDPARAM+'email-preferences-product-ofthe-week').attr('checked',true)
                                        }
                                         if(line == '114'){
                                            //recommended_for_you_enabled = true;
                                            jQuery(IDPARAM+'email-preferences-deal-ofthe-week').attr('checked',true)
                                        }
                                    });
                                }
                                
                                if(productInterestsArray)
                                var splitProductInterestsArray = productInterestsArray.split(',')

                                //console.log(splitProductInterestsArray)

                                if(productInterestsArray){
                                     _.each(splitProductInterestsArray,function(pi){
                                        if(pi == '1'){
                                            //arthroscopy_enabled = true;
                                             jQuery(IDPARAM+'product-interests-arthroscopy').attr('checked',true)
                                        }
                                        if(pi == '2'){
                                            //laproscopy_enabled = true;
                                            jQuery(IDPARAM+'product-interests-laproscopy').attr('checked',true)
                                        }
                                        if(pi == '3'){
                                            //urology_enabled = true;
                                            jQuery(IDPARAM+'product-interests-urology-gyno').attr('checked',true)
                                        }
                                        if(pi == '5'){
                                            //gyn_enabled = true;
                                            jQuery(IDPARAM+'product-interests-urology-gyno').attr('checked',true)
                                        }
                                        if(pi == '6'){
                                           // ent_enabled = true;
                                            jQuery(IDPARAM+'product-interests-ent').attr('checked',true)
                                        }
                                        if(pi == '7'){
                                           // orthopedic_enabled = true;
                                            jQuery(IDPARAM+'product-interests-orthopedic').attr('checked',true)
                                        }
                                        if(pi == '9'){
                                            //neurology_enabled = true;
                                            jQuery(IDPARAM+'product-interests-neurology').attr('checked',true)
                                        }
                                        if(pi == '12'){
                                            jQuery(IDPARAM+'product-interests-visualization').attr('checked',true)
                                            //visualization_enabled = true;
                                        }
                                       if(pi == '14'){
                                            //flexible_endoscopy_enabled = true;
                                            jQuery(IDPARAM+'product-interests-flexible-endoscopy').attr('checked',true)
                                        }
                                        if(pi == '16'){
                                          //  patient_care_enabled = true;
                                            jQuery(IDPARAM+'product-interests-patientcare').attr('checked',true)
                                        }
                                        if(pi == '18'){
                                            //imaging_enabled = true;
                                            jQuery(IDPARAM+'product-interests-imaging').attr('checked',true)
                                        }
                                        if(pi == '33'){
                                            jQuery(IDPARAM+'product-interests-sp').attr('checked',true)
                                           // surgical_power_enabled = true;
                                        }
                                        if(pi == '34'){
                                            jQuery(IDPARAM+'product-interests-sm').attr('checked',true)
                                            //sports_medicine_enabled = true;
                                        }
                                    });
                                }
                                jQuery('.offers-checkbox').each(function(){
                                    var self =this;
                                    var currentAttribute = jQuery(this)
                                    ,   currentAttributeIsChecked = jQuery(this).attr('checked')
                                    ,   currentAttributeId =jQuery(this).attr('id')

                                    if(Utils.isPhoneDevice())
                                        currentAttributeId = currentAttributeId.replace('in-modal-', '');

                                    //console.log(currentAttributeId)
                                    if(currentAttributeIsChecked)
                                    {
                                        jQuery(this).val("T");
                                        jQuery('.offers-plus-icon[data-attr="'+currentAttributeId+'"]').hide();
                                        jQuery('.offers-check-icon[data-attr="'+currentAttributeId+'"]').show();
                                    }
                                    else
                                    {   
                                        jQuery('.offers-check-icon[data-attr="'+currentAttributeId+'"]').hide();
                                        jQuery('.offers-plus-icon[data-attr="'+currentAttributeId+'"]').show();
                                    }
                                });
                            }
                            }, 500); 
                        }

                        /*if(isPerson == 'F' || isPerson == false)//if the user is company
                        {
                            var NewsletterPopupForm = new NewsletterSignupCompanyView({
                                application : self.application,
                                user : userInfo,
                                newsubscriber : res.newsubscriber
                             })
                        }
                        else
                        {
                        
                            var NewsletterPopupForm = new NewsletterSignupView({
                                application : self.application,
                                user : userInfo,
                                newsubscriber : res.newsubscriber
                            })

                        }

                        if (NewsletterPopupForm)
                        Layout.showContent(NewsletterPopupForm, {showInModal: true});*/
                    })
                    .always(_.bind(self.render, self));
            }
        }        

    ,   childViews: {
         GlobalMessageFeedback: function() {
                return new GlobalViewsMessageView({
                    message: this.state.message,
                    type: this.state.messageType,
                    closable: false
                });
            }
        }

        //@method getContext @return C3.ShoppingExtensions.NewsletterSignup.View.Context
    ,   getContext: function getContext()
        {
            return {
                // @property {Boolean} isFeedback
                isFeedback: !!this.state.code,
                // @property {Newsletter.Model} model
                model: this.model,
                loggedUserEmail : this.loggedUserEmail,
                isLoggedIn : this.is_logged_in
            };
        }
    });
});
